import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";
import { Splide, URLHash } from "../main.js";
import { updateVariantsWidth } from "../utils.js";
import {
  getStoreCategories,
  getStoreMaterialFilters,
  isFullRangeStore,
} from "../store-materials.js";
import { t } from "../texts.js";
const url = window.location.origin;

// SLIDER
const productVariant = document.querySelector(".js-product-variant");
const productPhoto = document.querySelector(".js-product-photo");

// Slider functions
const updateVariantName = (variant) => {
  const variantElement = document.querySelector(
    ".single-product__hero-title [data-variant]",
  );

  if (variant !== null && variant !== undefined && variantElement) {
    variantElement.textContent = `${variant}`;
  } else {
    variantElement.textContent = "";
  }
};

// Replace ? to # //new syntax
const replaceHashVariant = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get("variant");

  if (variant) {
    window.location.href = `${window.location.pathname}#variant=${variant}`;
  }
};

const updateVariantSpecification = (variants) => {
  const specificationElement = document.querySelector(".single-product__info");

  if (variants.collection !== undefined) {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-collection]",
    ).textContent = `${variants.collection}`;
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-collection]")
      .closest("li").style.display = "block";
  } else {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-collection]",
    ).textContent =
      `${document.querySelectorAll(".js-product-photo li[data-collection]:not(.splide__slide--clone)")[0].dataset.collection}`;
  }

  if (variants.color !== undefined) {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-color]",
    ).textContent = `${variants.color}`;
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-color]")
      .closest("li").style.display = "block";
  } else {
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-color]")
      .closest("li").style.display = "none";
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-color]",
    ).textContent = "";
  }

  if (variants.description !== undefined) {
    specificationElement.querySelector(
      ".single-product__description[data-description] p",
    ).textContent = `${variants.description}`;
  } else {
    specificationElement.querySelector(
      ".single-product__description[data-description] p",
    ).textContent =
      `${document.querySelectorAll(".js-product-photo li[data-description]:not(.splide__slide--clone)")[0].dataset.description}`;
  }

  if (variants.lensColor !== undefined) {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-lens-color]",
    ).textContent = `${variants.lensColor}`;
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-lens-color]")
      .closest("li").style.display = "block";
  } else {
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-lens-color]")
      .closest("li").style.display = "none";
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-lens-color]",
    ).textContent = "";
  }

  if (variants.lensVlt !== undefined) {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-lens-vlt]",
    ).textContent = `${variants.lensColor}`;
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-lens-vlt]")
      .closest("li").style.display = "block";
  } else {
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-lens-vlt]")
      .closest("li").style.display = "none";
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-lens-vlt]",
    ).textContent = "";
  }
};

if (productVariant && productPhoto) {
  // Call function for replace hash symbol
  replaceHashVariant();

  // GLOBAL
  let singleProductvariants;
  let singleProductphotos;

  // VARIANTS variables
  const productVariantLength =
    productVariant.querySelectorAll(".splide__slide").length;

  // CARDS variables
  const cardPhotoNextButton = document.querySelector(
    ".single-product__images .single-product__right-button",
  );
  const cardPhotoPrevButton = document.querySelector(
    ".single-product__images .single-product__left-button",
  );

  // VARIANTS SETTINGS
  singleProductvariants = new Splide(productVariant, {
    rewind: true,
    width: updateVariantsWidth(productVariantLength, 12, 5),
    perPage: productVariantLength <= 7 ? productVariantLength : 12,
    fixedWidth: 28,
    fixedHeight: 28,
    isNavigation: true,
    gap: 10,
    speed: 200,
    rewindSpeed: 100,
    focus: productVariantLength > 3 ? "center" : 0,
    easing: "cubic-bezier(.06,.78,.49,.98)",
    type: productVariantLength > 3 ? "loop" : "slide",
    pagination: false,
    arrows: false,
    drag: false,
    wheel: false,
    breakpoints: {
      1024: {
        width: updateVariantsWidth(productVariantLength, 9, 5),
        perPage: productVariantLength <= 5 ? productVariantLength : 9,
      },

      640: {
        width: updateVariantsWidth(productVariantLength, 7, 5),
        perPage: productVariantLength <= 4 ? productVariantLength : 7,
      },
    },
  });

  // PHOTO SETTINGS
  singleProductphotos = new Splide(productPhoto, {
    type: "loop",
    perPage: 2,
    perMove: 1,
    gap: 24,
    // heightRatio: 0.5,
    padding: "5rem",
    pagination: false,
    arrows: false,
    cover: true,
    focus: "center",
    speed: 700,
    lazyLoad: "sequential",

    breakpoints: {
      1920: {
        // perPage: 1,
        gap: 24,
        padding: "8rem",
      },

      1440: {
        // perPage: 1,
        gap: 24,
        padding: "3rem",
      },

      1024: {
        // perPage: 1,
        gap: 24,
        padding: "1rem",
      },

      768: {
        perPage: 1,
        gap: 10,
        padding: "4rem",
      },

      640: {
        perPage: 1,
        gap: 10,
        padding: "2rem",
      },
    },
  });

  // Events
  singleProductphotos.on("mounted", () => {
    updateVariantName(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset.variant,
    );
    updateVariantSpecification(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset,
    );
  });

  singleProductphotos.on("moved", () => {
    updateVariantName(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset.variant,
    );
    updateVariantSpecification(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset,
    );
  });

  // INIT
  singleProductvariants.mount({ URLHash });
  singleProductphotos.mount({ URLHash });
  singleProductphotos.sync(singleProductvariants);

  //attach events to custom buttons
  cardPhotoNextButton.addEventListener("click", (e) => {
    singleProductphotos.go("+1");
  });

  cardPhotoPrevButton.addEventListener("click", (e) => {
    singleProductphotos.go("-1");
  });
}

// STORES
let map;
let userLatitude;
let userLongitude;
let storeWrapper = document.querySelector(
  ".single-product__nearest-store-wrapper",
);
let storeMessage = document.querySelector(
  ".single-product__nearest-store-message",
);
let pinFullRange = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none'> <g clip-path='url(#clip0_1722_14351)'> <circle cx='12' cy='9' r='3' fill='#F8F7EE'/> <path d='M18 9.5C18 6.19 15.31 3.5 12 3.5C8.69 3.5 6 6.19 6 9.5C6 14 12 20.5 12 20.5C12 20.5 18 14 18 9.5ZM10 9.5C10 8.4 10.9 7.5 12 7.5C13.1 7.5 14 8.4 14 9.5C14 10.6 13.11 11.5 12 11.5C10.9 11.5 10 10.6 10 9.5Z' fill='#CC6633'/> </g> <defs> <clipPath id='clip0_1722_14351'> <rect width='24' height='24' fill='white'/> </clipPath> </defs> </svg>`;
let pinDefault = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none'> <g clip-path='url(#clip0_1564_8498)'> <circle cx='12' cy='9' r='3' fill='#F8F7EE'/> <path d='M18 9.5C18 6.19 15.31 3.5 12 3.5C8.69 3.5 6 6.19 6 9.5C6 14 12 20.5 12 20.5C12 20.5 18 14 18 9.5ZM10 9.5C10 8.4 10.9 7.5 12 7.5C13.1 7.5 14 8.4 14 9.5C14 10.6 13.11 11.5 12 11.5C10.9 11.5 10 10.6 10 9.5Z' fill='#27303E'/> </g> <defs> <clipPath id='clip0_1564_8498'> <rect width='24' height='24' fill='white'/> </clipPath> </defs> </svg>`;
let stores;

const STORE_CATEGORY_BY_COLLECTION = {
  titanium: "Titanium",
  "grand danois + sheet titanium": "Titanium",
  "imaginary lines": "Titanium",
  "sheet titanium": "Titanium",
  acetate: "Acetate",
  "ørgreen acetate": "Acetate",
  havn: "Nyhavn",
  nyhavn: "Nyhavn",
  quantum: "Quantum High",
  "quantum high": "Quantum High",
  "global fit": "Global FIT",
};

// Fetch stores
let getStores = async (count, lat, lng, collection) => {
  let storeResults = { products: [], distance: [] };
  let resultFilerDistance;
  const normalizedCollection = collection.trim().toLowerCase();
  const storeCategory = STORE_CATEGORY_BY_COLLECTION[normalizedCollection];
  const requestConfig = {};

  if (normalizedCollection !== "grand danois") {
    const materialFilters = getStoreMaterialFilters(storeCategory);

    if (materialFilters.length === 0) {
      return [];
    }

    requestConfig.params = { material: materialFilters.join("|") };
  }

  try {
    const response = await axios.get(
      `${url}/google/maps/distance/${count}/${lat}/${lng}`,
      requestConfig,
    );
    storeResults = response.data;
  } catch (err) {
    console.log(err);
    storeResults = { products: [], distance: [] };
  }

  if (JSON.parse(JSON.stringify(storeResults)).products.length !== 0) {
    let resultWithDistance = await JSON.parse(
      JSON.stringify(storeResults),
    ).products.map((store, index) => {
      let distanceIndex = JSON.parse(
        JSON.stringify(storeResults),
      ).distance.findIndex((x) => x.id === store.id);
      let storeDistance = store;

      storeDistance.distance = Math.round(
        JSON.parse(JSON.stringify(storeResults)).distance[distanceIndex]
          .distance,
      );
      return storeDistance;
    });

    resultFilerDistance = await resultWithDistance.filter((storeDistance) => {
      return Number(storeDistance.distance) <= 100;
    });

    resultFilerDistance.sort((a, b) => {
      return a.distance - b.distance;
    });
  } else {
    resultFilerDistance = [];
  }
  // Return final result with push distance item and filter 100km distance
  return await resultFilerDistance;
};

// Render stores
let renderStores = (findStores) => {
  findStores.forEach((store, index) => {
    // Template full range
    if (isFullRangeStore(store.material)) {
      storeWrapper.insertAdjacentHTML(
        "beforeend",
        `
      <button class="store-tag store-tag--full-range js-popup-open" type="button" data-index="${index}">
          <div class="store-tag__wrapper">
              <div class="store-tag__top">
                  <div class="store-tag__address">
                      <span class="store-tag__address-title">${store.name}</span>
                      <span class="store-tag__address-street">${store.address},</span> 
                      <span class="store-tag__address-state">${store.city} ${store.postcode}</span>

                      <div class="store-tag__full-range">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6H0ZM6 2.8C6.07606 2.79997 6.15055 2.82164 6.21474 2.86244C6.27893 2.90325 6.33015 2.96151 6.3624 3.0304L7.136 4.68L8.86 4.944C8.9326 4.9552 9.00071 4.98617 9.05687 5.03352C9.11303 5.08087 9.15507 5.14277 9.17838 5.21243C9.20168 5.28209 9.20535 5.35683 9.18898 5.42844C9.17262 5.50005 9.13685 5.56577 9.0856 5.6184L7.8272 6.9088L8.1256 8.736C8.13774 8.81016 8.12875 8.88623 8.09965 8.95552C8.07055 9.0248 8.02252 9.08448 7.96107 9.12773C7.89962 9.17098 7.82723 9.19605 7.7522 9.20006C7.67716 9.20406 7.60251 9.18686 7.5368 9.1504L6 8.3L4.4632 9.1504C4.39743 9.18693 4.32269 9.20416 4.24756 9.20013C4.17243 9.1961 4.09997 9.17096 4.03848 9.1276C3.977 9.08425 3.92899 9.02443 3.89996 8.95502C3.87094 8.88561 3.86208 8.80942 3.8744 8.7352L4.1728 6.9088L2.9136 5.6184C2.86211 5.56575 2.82616 5.4999 2.8097 5.42811C2.79324 5.35633 2.79693 5.2814 2.82034 5.21157C2.84375 5.14175 2.88599 5.07974 2.94239 5.03239C2.99879 4.98503 3.06718 4.95417 3.14 4.9432L4.8632 4.68L5.6376 3.0304C5.66985 2.96151 5.72107 2.90325 5.78526 2.86244C5.84945 2.82164 5.92394 2.79997 6 2.8Z" fill="#CC6633"/>
                          </svg>
                          <span class="store-tag__full-range-text">${t("Full Range Store")}</span>
                      </div>
                  </div>

                  <div class="store-tag__info">
                      <div class="store-tag__info-distance">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                              <path d="M8 4.33301C8 2.12634 6.20667 0.333008 4 0.333008C1.79333 0.333008 0 2.12634 0 4.33301C0 7.33301 4 11.6663 4 11.6663C4 11.6663 8 7.33301 8 4.33301ZM2.66667 4.33301C2.66667 3.59967 3.26667 2.99967 4 2.99967C4.73333 2.99967 5.33333 3.59967 5.33333 4.33301C5.33333 5.06634 4.74 5.66634 4 5.66634C3.26667 5.66634 2.66667 5.06634 2.66667 4.33301Z" fill="#27303E"/>
                          </svg>
                          <span class="store-tag__info-distance-text">${store.distance}km</span>
                      </div>
                      <a href="https://www.google.com/maps/dir/?api=1&origin=${userLatitude},${userLongitude}&destination=${store.latitude},${store.longtitude}&travelmode=driving" target="_blank" class="store-tag__info-direction">${t("Direction")}</a>
                  </div>
              </div>
          </div>
      </button>
      `,
      );
    } else {
      storeWrapper.insertAdjacentHTML(
        "beforeend",
        `
      <button class="store-tag js-popup-open" type="button" data-index="${index}">
        <div class="store-tag__wrapper">
            <div class="store-tag__top">
                <div class="store-tag__address">
                    <span class="store-tag__address-title">${store.name}</span>
                    <span class="store-tag__address-street">${store.address},</span> 
                    <span class="store-tag__address-state">${store.city} ${store.postcode}</span>
                </div>

                <div class="store-tag__info">
                    <div class="store-tag__info-distance">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                            <path d="M8 4.33301C8 2.12634 6.20667 0.333008 4 0.333008C1.79333 0.333008 0 2.12634 0 4.33301C0 7.33301 4 11.6663 4 11.6663C4 11.6663 8 7.33301 8 4.33301ZM2.66667 4.33301C2.66667 3.59967 3.26667 2.99967 4 2.99967C4.73333 2.99967 5.33333 3.59967 5.33333 4.33301C5.33333 5.06634 4.74 5.66634 4 5.66634C3.26667 5.66634 2.66667 5.06634 2.66667 4.33301Z" fill="#27303E"/>
                        </svg>
                        <span class="store-tag__info-distance-text">${store.distance}km</span>
                    </div>
                    <a href="https://www.google.com/maps/dir/?api=1&origin=${userLatitude},${userLongitude}&destination=${store.latitude},${store.longtitude}&travelmode=driving" target="_blank" class="store-tag__info-direction">${t("Direction")}</a>
                </div>
            </div>
        </div>
    </button>`,
      );
    }
  });
};

// Map
const mapStyle = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#F3F3F4",
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6D757F",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#F5F5F5",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#BDBDBD",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#FFFFFF",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9EA3AA",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#C9C9C9",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#A6D6DE",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9E9E9E",
      },
    ],
  },
];

// Popup
// popup--open
let popup = document.querySelector(".popup");
let popupList = document.querySelector(".popup__material-list");
let popupButtonClose = document.querySelectorAll(".js-popup-close");
let popupWindow = document.querySelector(".popup__window");
let popupWrapper = document.querySelector(".popup__wrapper");

// Google bills every map it creates, so the map is only made when a visitor opens a
// store, not on every product page view, and the same map is reused after that.
let mapsLibraries;
let storeMarker;

const loadMapsLibraries = () => {
  if (!mapsLibraries) {
    const loader = new Loader({
      apiKey: "AIzaSyBSTTa9ckso5eQfuOptR9LYLhwJ9-aYXpU",
      version: "quarterly",
    });

    mapsLibraries = Promise.all([
      loader.importLibrary("maps"),
      loader.importLibrary("marker"),
    ]).catch((err) => {
      mapsLibraries = null; // try again on the next click
      throw err;
    });
  }

  return mapsLibraries;
};

const showStoreOnMap = (store) => {
  const position = {
    lat: Number(store.latitude),
    lng: Number(store.longtitude),
  };
  const pin = isFullRangeStore(store.material) ? pinFullRange : pinDefault;

  loadMapsLibraries()
    .then(([{ Map: GoogleMap }, { AdvancedMarkerElement }]) => {
      if (!map) {
        map = new GoogleMap(document.getElementById("map"), {
          zoom: 9,
          disableDefaultUI: true,
          center: position,
          mapId: "563f50d500c53a0b",
        });
      } else {
        map.setZoom(9);
        map.setCenter(position);
      }

      if (storeMarker) {
        storeMarker.map = null;
      }
      storeMarker = new AdvancedMarkerElement({
        map: map,
        position: position,
        content: new DOMParser().parseFromString(pin, "image/svg+xml")
          .documentElement,
      });
    })
    .catch((err) => {
      console.error(
        "Error loading Google Maps libraries or initializing the map:",
        err,
      );
    });
};

// Function open popup
let popupOpen = (index) => {
  let popupTitle = document.querySelector(".popup__title");
  let popupAddress = document.querySelector(".popup__information-data-address");
  let popupWebsite = document.querySelector(".popup__information-data-website");
  let popupEmail = document.querySelector(".popup__information-data-email");
  let popupPhone = document.querySelector(".popup__information-data-phone");
  let popupDirectionButton = document.querySelector(".popup__button-direction");

  showStoreOnMap(stores[index]);

  if (stores[index].internet_address !== null) {
    popupWebsite.querySelector(".popup__information-data-link").textContent =
      stores[index].internet_address;
    popupWebsite.querySelector(".popup__information-data-link").href =
      "https://" + stores[index].internet_address;
  } else {
    popupWebsite.setAttribute("style", "display: none;");
  }

  if (stores[index].email) {
    popupEmail.querySelector(".popup__information-data-link").textContent =
      stores[index].email;
    popupEmail.querySelector(".popup__information-data-link").href =
      "mailto:" + stores[index].email;
  } else {
    popupEmail.setAttribute("style", "display: none;");
  }

  if (stores[index].telephone) {
    popupPhone.querySelector(".popup__information-data-link").textContent =
      stores[index].telephone;
    popupPhone.querySelector(".popup__information-data-link").href =
      "tel:" + stores[index].telephone;
  } else {
    popupPhone.setAttribute("style", "display: none;");
  }
  // PopUp content
  popupTitle.textContent = stores[index].name;
  popupAddress.querySelector(".popup__information-data-link").textContent =
    stores[index].address;
  popupAddress.querySelector(".popup__information-data-link").href =
    `https://www.google.com/maps/place/${stores[index].address},+${stores[index].postcode},${stores[index].city},+${stores[index].country}`;
  popupDirectionButton.href = `https://www.google.com/maps/dir/?api=1&origin=${userLatitude},${userLongitude}&destination=${stores[index].latitude},${stores[index].longtitude}&travelmode=driving`;

  if (isFullRangeStore(stores[index].material)) {
    popup.classList.add("popup--full-range");
  }

  let paddingTotal =
    parseInt(window.getComputedStyle(popupWindow).paddingTop) +
    parseInt(window.getComputedStyle(popupWindow).paddingBottom);
  popup.classList.add("popup--open");
  document.querySelector("body").setAttribute("style", "overflow: hidden;");
  popupWrapper.setAttribute(
    "style",
    `height:${popupWindow.offsetHeight - paddingTotal}px;`,
  );

  let titleWidth = Array.from(
    popupWrapper.querySelectorAll(".popup__information-data-title"),
  ).map((e) => {
    return e.offsetWidth;
  });

  Array.from(
    popupWrapper.querySelectorAll(".popup__information-data-title"),
  ).forEach((e) => {
    e.style.width =
      titleWidth.sort(function (a, b) {
        return a - b;
      })[titleWidth.length - 1] + "px";
  });

  getStoreCategories(stores[index].material).forEach((category) => {
    popupList
      .querySelector(`[data-store-category="${category}"]`)
      ?.classList.remove("disabled");
  });
};

let popupClose = () => {
  let popupWebsite = document.querySelector(".popup__information-data-website");
  let popupEmail = document.querySelector(".popup__information-data-email");
  let popupPhone = document.querySelector(".popup__information-data-phone");

  popup.classList.remove("popup--open");
  document.querySelector("body").removeAttribute("style");
  popupWrapper.removeAttribute("style");
  popup.classList.remove("popup--full-range");
  popupWebsite.removeAttribute("style");
  popupEmail.removeAttribute("style");
  popupPhone.removeAttribute("style");

  Array.from(
    popupWrapper.querySelectorAll(".popup__information-data-title"),
  ).forEach((e) => {
    e.removeAttribute("style");
  });

  Array.from(popupList.querySelectorAll("li")).forEach((e) => {
    e.classList.add("disabled");
  });
};

Array.from(popupButtonClose).forEach((e) => {
  e.addEventListener("click", () => {
    popupClose();
  });
});

// Close popup on click popup background
document.addEventListener("click", (e) => {
  if (e.target.classList.contains("popup--open")) {
    popupClose();
  }
});

try {
  document
    .querySelector(".single-product__nearest-store-wrapper")
    .addEventListener("click", (e) => {
      if (
        e.target.classList[0] !== "store-tag__info-direction" &&
        e.target.closest(".js-popup-open")
      ) {
        popupOpen(e.target.closest(".js-popup-open").dataset.index);
      }
    });
} catch (err) {
  console.log(err);
}

function success(position) {
  userLatitude = position.coords.latitude;
  userLongitude = position.coords.longitude;
  let collectionStore = document.querySelector(".single-product__hero-title")
    .dataset.collection;

  getStores(3, userLatitude, userLongitude, collectionStore)
    .then((response) => {
      if (response.length !== 0) {
        storeMessage.setAttribute("style", "display: none;");
        renderStores(response);
        stores = response;
      } else {
        storeMessage.setAttribute("style", "display: block;");
        storeMessage.textContent = t("No shops were found within 100 km.");
      }
    })
    .catch((err) => {
      console.log(err);
      storeMessage.setAttribute("style", "display: block;");
      storeMessage.textContent = t("No shops were found within 100 km.");
    });
}

function error() {
  storeMessage.innerHTML = t(
    'To locate your nearest retailer you need to enable geolocation in your browser. <a href="https://whatismyipaddress.com/enabling-and-disabling-geolocation-on-your-browser" target="_blank">More info</a>',
  );
}

// The nearest stores come from our own endpoint, so a product page view doesn't
// load Google Maps at all; see showStoreOnMap().
if (document.querySelector(".single-product")) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error);
  } else {
    storeMessage.innerHTML = t("Geolocation is not supported by your browser");
  }
}
